import React, { useState, useEffect } from 'react';
import axios from 'axios';
import io from 'socket.io-client';
import MainContent from './components/MainContent';
import AuthContainer from './components/Auth/AuthContainer';
import AreaAccessSelector from './components/Auth/AreaAccessSelector';
import useAuth from './hooks/useAuth';
import { socketBaseUrl } from './config/runtime';
import './styles/App.css';

const companyCode = localStorage.getItem('companyCode') || '';
const socket = io(socketBaseUrl, { query: { company_code: companyCode } });

const App = () => {
  const { isAuthenticated, setIsAuthenticated, handleLogout, userId, role } = useAuth();
  const [showAreaSelector, setShowAreaSelector] = useState(localStorage.getItem('pendingAreaSelection') === '1');
  const [theme, setTheme] = useState('dark'); // Valor padrão do tema

  useEffect(() => {
    // Recupera o tema armazenado no localStorage
    const savedTheme = localStorage.getItem('theme') || 'dark';
    setTheme(savedTheme);
    document.body.className = savedTheme;
  }, []);

  useEffect(() => {
    if (companyCode) {
      axios.defaults.headers.common['X-Company-Code'] = companyCode;
    }
  }, []);

  useEffect(() => {
    setShowAreaSelector(isAuthenticated && localStorage.getItem('pendingAreaSelection') === '1');
  }, [isAuthenticated]);

  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error?.response?.status;
        const payloadMessage = String(
          error?.response?.data?.msg || error?.response?.data?.message || ''
        ).toLowerCase();
        const currentToken = localStorage.getItem('token');
        const url = String(error?.config?.url || '');
        const isAuthRequest = url.endsWith('/login') || url.endsWith('/register');
        const isTokenError = status === 401 || status === 422 || payloadMessage.includes('token') || payloadMessage.includes('jwt');

        if (currentToken && isTokenError && !isAuthRequest) {
          handleLogout();
          window.location.reload();
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptorId);
    };
  }, [handleLogout]);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.body.className = newTheme;
  };

  return (
    <div className={`app ${theme}`}>
      {isAuthenticated && showAreaSelector ? (
        <AreaAccessSelector
          onConfirm={() => setShowAreaSelector(false)}
          onLogout={() => {
            handleLogout();
            setShowAreaSelector(false);
          }}
        />
      ) : isAuthenticated ? (
        <MainContent
          socket={socket}
          handleLogout={handleLogout}
          userId={userId}
          role={role}
          toggleTheme={toggleTheme} // Passa a função para alternar o tema
        />
      ) : (
        <AuthContainer onLogin={() => setIsAuthenticated(true)} />
      )}
    </div>
  );
};

export default App;
